import React, { useState } from 'react';

import PropTypes from 'prop-types';
import { makeStyles } from '@mui/styles';
import { Button, Modal as MUIModal, Typography, Box } from '@mui/material';

function getModalStyle() {
  const top = 50;
  const left = 50;

  return {
    position: 'absolute',
    top: `${top}%`,
    left: `${left}%`,
    transform: `translate(-${top}%, -${left}%)`,
  };
}

const useStyles = makeStyles((theme) => ({
  paper: {
    position: 'absolute',
    zIndex: 1,
    outline: 0,
    width: 400,
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
  },
}));

const Modal = ({ children, buttonText, title, CustomButton, customStyles }) => {
  const classes = useStyles();
  const [modalStyle] = useState(getModalStyle);

  const [open, setOpen] = useState(false);

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  return (
    <>
      {CustomButton ? (
        <CustomButton {...{ handleOpen, buttonText }} />
      ) : (
        <Button
          style={{ margin: '10px', marginLeft: '0px' }}
          variant="outlined"
          onClick={handleOpen}>
          {buttonText}
        </Button>
      )}
      <MUIModal
        aria-labelledby="simple-modal-title"
        aria-describedby="simple-modal-description"
        open={open}
        onClose={handleClose}>
        <div
          style={{ ...modalStyle, ...customStyles }}
          className={classes.paper}>
          {title && (
            <Box my="20px" component={Typography} variant="h4">
              {title}
            </Box>
          )}
          {typeof children === 'function'
            ? children({ open, handleClose, handleOpen })
            : children}
        </div>
      </MUIModal>
    </>
  );
};

Modal.propTypes = {
  customStyles: PropTypes.object,
  buttonText: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  Component: PropTypes.elementType,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
    PropTypes.func,
  ]).isRequired,
};

export default Modal;
